<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('infoInquiry.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('infoInquiry.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('infoInquiry.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('infoInquiry.registeredDate')
                      }}</label>
                      <a-range-picker
                        format="DD-MM-YYYY"
                        :defaultValue="rangeDate"
                        :defaultPickerValue="rangeDate"
                        @change="dateRangeChange"
                      >
                        <template slot="renderExtraFooter"></template>
                      </a-range-picker>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('infoInquiry.branchName')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('infoInquiry.registeredStatus')
                      }}</label>
                      <a-select
                        v-model="model.is_registered"
                        style="width: 100%"
                      >
                        <a-select-option :value="null">All</a-select-option>
                        <a-select-option :value="true">Yes</a-select-option>
                        <a-select-option :value="false">No</a-select-option>
                      </a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('infoInquiry.soureOfInquiry')
                      }}</label>
                      <a-select
                        v-model="model.soure_of_inquiry"
                        style="width: 100%"
                      >
                        <a-select-option value="all">All</a-select-option>
                        <a-select-option value="leaflet"
                          >Leaf let</a-select-option
                        >
                        <a-select-option value="newspaper"
                          >Newspaper</a-select-option
                        >
                        <a-select-option value="tv">Tv</a-select-option>
                        <a-select-option value="accross_the_road">
                          Accross The Road
                        </a-select-option>
                        <a-select-option value="friend">
                          Friend
                        </a-select-option>
                        <a-select-option value="facebooks">
                          Facebooks
                        </a-select-option>
                        <a-select-option value="relative">
                          Relative
                        </a-select-option>
                        <a-select-option value="marketing_agent">
                          Marketing Agent
                        </a-select-option>
                        <a-select-option value="walk_in">
                          Walk In
                        </a-select-option>
                        <a-select-option value="refferal">
                          Refferal
                        </a-select-option>
                        <a-select-option value="radio">Radio</a-select-option>
                        <a-select-option value="other">Other</a-select-option>
                      </a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('infoInquiry.statisticBy') }}</label>
                      <a-select
                        v-model="model.statistic_by"
                        style="width: 100%"
                        mode="multiple"
                        placeholder="All"
                      >
                        <!-- <a-select-option value="scource"
                          >Scource</a-select-option
                        > -->
                        <a-select-option value="from_school"
                          >From School</a-select-option
                        >
                        <a-select-option value="sub_program"
                          >Sub Program</a-select-option
                        >
                        <a-select-option value="enrollment">
                          Enrollment
                        </a-select-option>
                      </a-select>
                      <div class="validate" v-if="errors.has('statistic_by')">
                        {{ errors.first('statistic_by') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('infoInquiry.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'infoInquiry',
  data () {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      rangeDate: [moment(), moment()],
      model: {
        branch_id: null,
        is_registered: null,
        soure_of_inquiry: 'all',
        statistic_by: undefined
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', ['getBranch', 'infoInquiry']),
    async fetchData () {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
        this.model.branch_id = this.$store.state.authUser.default_branch_id
      })
      this.loading = false
    },
    preview () {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.infoInquiry(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'reportAcademic/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportAcademic/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    }
  }
}
</script>
